import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import styles from "./PageTitle.module.scss";
import AuthContext from "../../hooks/authContext";
import { Button } from "../ui/button";
import { useMediaQuery } from "@mui/material";
const PageTitle = (props) => {
  const auth = useContext(AuthContext);
  const isMobile = useMediaQuery("(max-width:767px)");
   const [openDropdown, setOpenDropdown] = useState(false);

  const handleSelect = (option) => {
    setOpenDropdown(false); 
    props?.onDropdownSelect?.(option);
  };

  const showBreadcrumb = () => {
    return (
      <ul className={`clear breadcrumbs ${styles.breadcrumbWrap} `}>
        {props.showBreadcrumb?.map((bitem, bindex) => {
          return (
            <li key={bindex}>
              {bitem.label === "Channels" && props.live === true ? (
                <button
                  onClick={() => auth.setCurrentChannel(null)}
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                  className={styles.channelLink}
                >
                  {bitem.label}
                </button>
              ) : (
                <Link to={bitem.to}        
                onClick={() => {
                  if (bitem.label === "Home") {
                    auth.setIsExpanded(false);
                  }
                  bitem.onclick?.();
                }}
                className="dark:text-gray-500"
                >{bitem.label}</Link>
              )}
              <span>
                <ChevronRightIcon />
              </span>
            </li>
          );
        })}
        <li>
          <span className={`${styles.active} text-foreground`}>
            {props?.BreadCrumbCurrentPageTitle
              ? props?.BreadCrumbCurrentPageTitle
              : props.pageTitle}
          </span>
        </li>
      </ul>
    );
  };

  // const showLastSeen = () => {
  //   let profile = auth?.userProfile;
  //   return (
  //     auth?.status === true &&
  //     profile && (
  //       <>
  //         Last Login:{" "}
  //         <strong>
  //           {Moment(profile?.lastLogin).format("MMMM D, YYYY h:mm:ss")}
  //         </strong>
  //       </>
  //     )
  //   );
  // };

  return (
    <div
      className="dark:bg-[#1A1F2C] d-flex flex-space-between flex-center shadow-[0_1px_3px_rgba(0,0,0,0.1)] dark:shadow-[0_4px_6px_rgba(2,8,23,0.8)] "
      style={{ marginBottom: "10px" }}
    >
      <div style={{ padding: "10px 0px 10px 15px" }}>
        <div className={styles.pageTitleWrap} style={{ paddingLeft: "5px" }}>
          <div>
            <h4 className={`${styles.pageTitle} text-foreground`}>
              {props.pageTitle}
            </h4>
            {props.showBreadcrumb &&
              props.showBreadcrumb !== false &&
              showBreadcrumb()}
          </div>
          {/* <div className={styles.rightTitle}>
        {props.showLastSeen && props.showLastSeen !== false && showLastSeen()}
      </div> */}
        </div>
      </div>
      <div className={"d-flex flex-direction-column flex-center mv-20"}>
        {props?.buttonDropdown === true ? (
          <div className={isMobile ? "relative mr-15" : "relative mr-40"}>
            <Button
              className={props?.buttonClass}
              onClick={() => setOpenDropdown(!openDropdown)}
            >
              {props?.icons}
              <span>{props?.buttonTitle}</span>
            </Button>

            {openDropdown && (
              <div className="absolute right-0 mt-8 w-48 bg-white border rounded shadow z-50 dark:bg-[#1A1F2C] dark:text-white">
                {props?.dropdownOptions?.map((opt) => (
                  <div
                    key={opt.value}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer dark:hover:bg-gray-700"
                    onClick={() => handleSelect(opt)}
                  >
                    {opt.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <>
            {props?.buttonTitle && (
              <div className={isMobile ? "mr-15" : "mr-40"}>
                <Button
                  className={props?.buttonClass}
                  style={props?.buttonStyle}
                  onClick={props?.buttonClick}
                >
                  {props?.icons}
                  <span>{props?.buttonTitle}</span>
                </Button>
              </div>
            )}

            {props?.buttonTitle2 && props?.buttonTitle2 !== "" && (
              <div className={isMobile ? "mr-15 mt-10" : "mr-40 mt-10"}>
                <span
                  className="cursor-pointer text-blue-600 underline"
                  onClick={props?.buttonClick2}
                >
                  <span className="ml-4">{props?.buttonTitle2}</span>
                </span>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PageTitle;
